import { Box } from "@mui/material";
import CultureForm from "../components/forms/cultureForm.component";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { updateCultureStart } from "../store/features/culture/cultureSlice";

const UpdateCulturePage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const crops = useSelector((state) => state.crops?.data?.data);
  const accessToken = useSelector((state) => state.auth?.user?.access_token);
  const { isLoading, error, success } = useSelector((state) => state.culture);

  const culture = crops?.find((c) => String(c.id) === String(id));

  const onSubmit = (data) => {
    dispatch(
      updateCultureStart({ data, accessToken: accessToken, cultureId: id })
    );
  };

  return (
    <Box width="100%">
      <CultureForm
        mode="update"
        defaultValues={culture}
        onSubmit={onSubmit}
        accessToken={accessToken}
        culture={culture}
        error={error}
        isLoading={isLoading}
        success={success}
      />
    </Box>
  );
};

export default UpdateCulturePage;
